var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
/**
 * <vitesse-toggle> — themed on/off switch. Reusable everywhere; size via the
 * `size` attribute (sm | md | lg). Blue when on, themes automatically.
 *
 *   <vitesse-toggle ?checked=${b} size="md"
 *       @change=${(e) => (b = e.detail.checked)}></vitesse-toggle>
 *
 * Emits a `change` CustomEvent<{ checked: boolean }>.
 */
let VitesseToggle = class VitesseToggle extends LitElement {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.disabled = false;
        this.size = 'md';
    }
    static { this.styles = css `
    :host { display: inline-block; --track-w: 40px; --track-h: 22px; --knob: 16px; }
    :host([size='sm']) { --track-w: 32px; --track-h: 18px; --knob: 13px; }
    :host([size='lg']) { --track-w: 50px; --track-h: 28px; --knob: 22px; }

    button {
      position: relative;
      width: var(--track-w);
      height: var(--track-h);
      border-radius: 999px;
      border: 1px solid var(--border-color-light);
      background: var(--bg-tertiary);
      cursor: pointer;
      padding: 0;
      transition: background-color 0.2s ease, border-color 0.2s ease;
    }
    button:focus-visible { outline: 2px solid var(--blue); outline-offset: 2px; }
    .knob {
      position: absolute;
      top: 50%;
      left: 2px;
      width: var(--knob);
      height: var(--knob);
      border-radius: 50%;
      /* Off state should read as quiet, not heavy — a light knob (tertiary), not the darker secondary. */
      background: var(--text-tertiary);
      transform: translate(0, -50%);
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), background-color 0.2s ease;
    }
    :host([checked]) button { background: var(--blue); border-color: var(--blue); }
    :host([checked]) .knob { background: #fff; transform: translate(calc(var(--track-w) - var(--knob) - 6px), -50%); }
    :host([disabled]) button { opacity: 0.5; cursor: not-allowed; }
  `; }
    toggle() {
        if (this.disabled)
            return;
        this.checked = !this.checked;
        this.dispatchEvent(new CustomEvent('change', { detail: { checked: this.checked }, bubbles: true, composed: true }));
    }
    render() {
        return html `
      <button type="button" role="switch" aria-checked=${this.checked} ?disabled=${this.disabled} @click=${this.toggle}>
        <span class="knob"></span>
      </button>
    `;
    }
};
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseToggle.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], VitesseToggle.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], VitesseToggle.prototype, "size", void 0);
VitesseToggle = __decorate([
    customElement('vitesse-toggle')
], VitesseToggle);
export { VitesseToggle };
//# sourceMappingURL=vitesse-toggle.js.map